import React, { useEffect, useState } from 'react';
import axios from 'axios';
import exportarUbicacionesAExcel from './ExcelProductosxUbicacion';
import { Box, Button, Card, CardContent } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

const BarUbicaciones = () => {
    const [empresaIdEmpresa, setEmpresaIdEmpresa] = useState(null);
    const [data, setData] = useState([]);
    const [labels, setLabels] = useState([]);
    const [detalle, setDetalle] = useState([]);

    const obtenerInventariosURL = 'https://invio.datachile.site/Web/Reportes/ProductoxUbicacion.php';

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('usuario'));
        if (userData?.empresa_idEmpresa) {
            setEmpresaIdEmpresa(userData.empresa_idEmpresa);
            getInventarios(userData.empresa_idEmpresa);
        }
    }, []);

    const getInventarios = async (empresaId) => {
        try {
            const response = await axios.post(obtenerInventariosURL, { empresa_idEmpresa: empresaId });
            const apiData = response.data;

            const ubicaciones = Object.keys(apiData);
            const cantidades = Object.values(apiData).map(productos => productos.length);

            setLabels(ubicaciones);
            setData([{ data: cantidades, label: 'Cantidad de productos' }]);
            setDetalle(apiData);
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    };

    return (
        <Card
            sx={{
                backgroundColor: '#e3eaf0',
                boxShadow: 3,
                borderRadius: '16px',
                width: 370,
                height: 320,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CardContent sx={{ width: '100%', height: '100%', padding: 1 }}>
                <Box sx={{ width: '100%', height: '100%' }}>
                    <h2>Ubicaciones</h2>
                    <Box sx={{ width: '100%', height: '80%', marginTop: -4 }}>
                        <BarChart
                            xAxis={[{ scaleType: 'band', data: labels }]}
                            series={data}
                            width={350}
                            height={220}
                            colors={['#1bbac5']}
                        />
                    </Box>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ marginTop: 0 }}
                        onClick={() => exportarUbicacionesAExcel(detalle)}
                    >
                        Exportar a Excel
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default BarUbicaciones;
